var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { connect } from "@irati/store";
import Modal from "@irati/ui/src/Modal";
import modalStory from "@irati/utils/modalStory";
import { LangLoader, injectIntl } from "@irati/utils/lang";
import { perksGOTracking } from "@irati-tracking/perksgo";
import FidelScript from "@irati-web/platform/src/utils/fidel";
import authentication from "@irati/auth";
import { greys, callToAction } from "@irati/ui/src/global/colors";
import { getFidelCredentials } from "@irati/perksgo/helpers/fidel";
import { PERKSGO } from "@irati-web/app/src/routeConfig";
import perksGOLogo from "../../../images/perksGO_logoAndText.svg";
import Success from "./Success";
import { SuccessModal, ImageWrapper } from "./styled/Popup";
export var SUCCESS = "SUCCESS";
var modals = [SUCCESS];
var LinkCardPopup = /** @class */ (function (_super) {
    __extends(LinkCardPopup, _super);
    function LinkCardPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            modalShow: modalStory(modals, null)
        };
        _this.setupFidelSDK = function () {
            var formatMessage = _this.props.formatMessage;
            var _a = getFidelCredentials(), programId = _a.programId, publicKey = _a.publicKey;
            window.fidelSDKMetadata = {
                id: "perksGO-metadata",
                userUuid: authentication.user().uuid
            };
            window.fidelSDKCardCallback = _this.handleFidelSDKCardCallback;
            // hard code to GBR until we support other countries
            var countryCode = "GBR";
            return FidelScript.setup({
                "data-company-name": "Perkbox",
                "data-key": publicKey,
                "data-program-id": programId,
                "data-button-color": callToAction.default,
                "data-button-title-color": greys.black,
                "data-terms-color": greys.black,
                "data-auto-open": "false",
                "data-auto-close": "false",
                "data-country-code": countryCode,
                "data-logo": "https://res.cloudinary.com/perkbox/image/upload/v1562836543/32d03643-cc4a-4d97-ac13-dae95b4f0eac.png",
                "data-subtitle": formatMessage({ id: "perksgo.popup.linkCard.fidelSDK.subTitle" }),
                "data-metadata": "fidelSDKMetadata",
                "data-callback": "fidelSDKCardCallback",
                "data-close-events": "true",
                "data-delete-instructions": formatMessage({ id: "perksgo.popup.linkCard.fidelSDK.deleteInstructions" }),
                "data-privacy-url": formatMessage({ id: "perksgo.popup.linkCard.fidelSDK.privacyUrl" })
            });
        };
        _this.show = function () {
            _this.setupFidelSDK().then(function () {
                var fidel = window.Fidel;
                if (fidel) {
                    fidel.openForm();
                }
            });
        };
        _this.showModal = function (modalToShow) {
            _this.setState(function (_a) {
                var modalShow = _a.modalShow;
                return ({
                    modalShow: modalStory(modals, modalToShow, modalShow)
                });
            });
        };
        _this.hideModal = function () {
            _this.setState({
                modalShow: modalStory(modals, null)
            });
            var onHide = _this.props.onHide;
            if (onHide) {
                onHide();
            }
        };
        _this.handleFidelSDKCardCallback = function (error, card) {
            var linkedCards = _this.props.linkedCards;
            if (!error && card) {
                perksGOTracking.cardSuccessfullyLinked(linkedCards.length + 1);
                var fidel = window.Fidel;
                if (fidel) {
                    fidel.closeForm();
                }
                // refresh cards list so by the time the popup is closed, the list will have updated
                _this.setState({ lastFour: parseInt(card.lastNumbers, 10) }, function () {
                    _this.showModal(SUCCESS);
                });
            }
        };
        return _this;
    }
    LinkCardPopup.prototype.componentWillUnmount = function () {
        delete window.fidelSDKMetadata;
        delete window.fidelSDKCardCallback;
    };
    LinkCardPopup.prototype.render = function () {
        var _a = this.props, isMobile = _a.isMobile, isInDeal = _a.isInDeal, formatMessage = _a.formatMessage;
        var _b = this.state, modalShow = _b.modalShow, lastFour = _b.lastFour;
        var ModalSuccess = isMobile ? Modal : SuccessModal;
        return (React.createElement(LangLoader, { bucket: PERKSGO },
            React.createElement(ModalSuccess, { className: isMobile && "modal-slide-up modal-full-screen", renderHeader: function () { return (React.createElement(ImageWrapper, null,
                    React.createElement("img", { src: perksGOLogo, alt: formatMessage({ id: "platform.perksGO.popup.linkedCard.logo.alt" }) }))); }, show: modalShow[SUCCESS], onHide: this.hideModal },
                React.createElement(Success, { lastFour: lastFour, onComplete: this.hideModal, isInDeal: isInDeal }))));
    };
    LinkCardPopup.defaultProps = {
        onHide: function () { },
        isInDeal: false
    };
    return LinkCardPopup;
}(Component));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return {
        isMobile: mq.lessThan.medium
    };
};
export default injectIntl(connect(mapStateToProps, {}, null, { withRef: true })(LinkCardPopup), { withRef: true });
